import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

/**
 * The project container, as an Enterprise Component.
 *
 * A PROJECT IS NOT A SPECIES AND THIS DOES NOT MAKE IT ONE. There is no revision chain, no
 * approval and no signature; what gets revised is the offer, the contract and the plan inside it.
 * The component exists so the folder list can use the platform's own table -- paging, sorting,
 * searching, the column picker and the card view -- rather than a second hand-rolled list that
 * would drift from all of them.
 *
 * THE COUNTS ARE FLATTENED. The service answers with a nested `Counts` object, which is the right
 * shape for a document and the wrong one for a grid: a column is addressed by a single attribute
 * name. The payload mapper spreads them into CountContract, CountBuildPlan and the rest, and
 * CountFiled is their sum -- computed in the mapper rather than by each caller.
 *
 * CustomerName IS NOT A COLUMN THE SERVICE RETURNS. The project carries only CustomerObjectUSID;
 * the name is resolved against the customer's own read, which applies that record's visibility.
 * It is declared here so a card can place it and a grid can show it once resolved.
 */
class ProjectEnterpriseComponentMetadata extends EnterpriseComponentMetadata {

    constructor() {
        super();

        this.name = "Project";
        this.defaultCacheSize = 200;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", false, false, false, false, null, null, null, null, null, null,
            "String", null, false,
        );
        this.attributes["Name"] = new EnterpriseComponentAttributeMetadata(
            "Name", false, false, false, false, null, null, null, null, null, null,
            "String", null, false,
        );
        this.attributes["Description"] = new EnterpriseComponentAttributeMetadata(
            "Description", false, false, false, false, null, null, null, null, null, null,
            "String", null, false,
        );
        this.attributes["Status"] = new EnterpriseComponentAttributeMetadata(
            "Status", false, false, false, false, null, null, null, null, null, null,
            "String", null, false,
        );
        this.attributes["CustomerObjectUSID"] = new EnterpriseComponentAttributeMetadata(
            "CustomerObjectUSID", false, false, false, false, null, null, null, null, null, null,
            "String", null, false,
        );
        this.attributes["CustomerName"] = new EnterpriseComponentAttributeMetadata(
            "CustomerName", false, false, false, false, null, null, null, null, null, null,
            "String", null, false,
        );
        this.attributes["ClosedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "ClosedDatetime", false, false, false, false, null, null, null, null, null, null,
            "DateTime", null, false,
        );
        this.attributes["CreatedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "CreatedDatetime", false, false, false, false, null, null, null, null, null, null,
            "DateTime", null, false,
        );
        this.attributes["CountProduct"] = new EnterpriseComponentAttributeMetadata(
            "CountProduct", false, false, false, false, null, null, null, null, null, null,
            "Number", null, false,
        );
        this.attributes["CountQuoteRequest"] = new EnterpriseComponentAttributeMetadata(
            "CountQuoteRequest", false, false, false, false, null, null, null, null, null, null,
            "Number", null, false,
        );
        this.attributes["CountPreparedQuote"] = new EnterpriseComponentAttributeMetadata(
            "CountPreparedQuote", false, false, false, false, null, null, null, null, null, null,
            "Number", null, false,
        );
        this.attributes["CountContract"] = new EnterpriseComponentAttributeMetadata(
            "CountContract", false, false, false, false, null, null, null, null, null, null,
            "Number", null, false,
        );
        this.attributes["CountBuildPlan"] = new EnterpriseComponentAttributeMetadata(
            "CountBuildPlan", false, false, false, false, null, null, null, null, null, null,
            "Number", null, false,
        );
        this.attributes["CountFiled"] = new EnterpriseComponentAttributeMetadata(
            "CountFiled", false, false, false, false, null, null, null, null, null, null,
            "Number", null, false,
        );
    }
}

export default ProjectEnterpriseComponentMetadata;
